module.exports = __webpack_public_path__ + "img/jiulonghudujiacun.12d87524.png";